// Adapter kế thừa: liệt kê bài học có sẵn trong chương trình (du-lieu/noi-dung)
// và nạp nội dung gốc (ContentItem[]) để tái sử dụng — KHÔNG sửa dữ liệu gốc.
import type { ContentItem } from '../../../types'

// Danh sách đường dẫn bài học gốc (khớp manifest của LessonService).
const CURRICULUM_PATHS: string[] = [
  'lop-10/chuong-0-mo-dau/bai-1-gioi-thieu-muc-dich-hoc-tap-mon-vat-li',
  'lop-10/chuong-1-dong-hoc/bai-2-do-dich-chuyen-va-quang-duong-di-duoc',
  'lop-10/chuong-1-dong-hoc/bai-3-toc-do-va-van-toc-chuyen-dong-tong-hop',
  'lop-10/chuong-1-dong-hoc/bai-4-do-thi-do-dich-chuyen-thoi-gian',
  'lop-10/chuong-1-dong-hoc/bai-5-chuyen-dong-bien-doi',
  'lop-10/chuong-1-dong-hoc/bai-6-chuyen-dong-roi-tu-do',
  'lop-10/chuong-1-dong-hoc/bai-7-chuyen-dong-nem',
  'lop-10/chuong-2-dong-luc-hoc/bai-8-ba-dinh-luat-newton-ve-chuyen-dong',
  'lop-10/chuong-2-dong-luc-hoc/bai-9-mot-so-luc-trong-thuc-tien',
  'lop-10/chuong-2-dong-luc-hoc/bai-10-tong-hop-luc-va-phan-tich-luc',
  'lop-10/chuong-2-dong-luc-hoc/bai-11-can-bang-luc-moment-luc',
  'lop-10/chuong-2-dong-luc-hoc/bai-12-khoi-luong-rieng-ap-suat-chat-long',
  'lop-10/chuong-3-nang-luong-va-cong/bai-13-cong-va-nang-luong',
  'lop-10/chuong-3-nang-luong-va-cong/bai-14-dong-nang-va-the-nang',
  'lop-10/chuong-3-nang-luong-va-cong/bai-15-cong-suat-va-hieu-suat',
  'lop-10/chuong-3-nang-luong-va-cong/bai-16-dong-luong-dinh-luat-bao-toan-dong-luong',
  'lop-10/chuong-3-nang-luong-va-cong/bai-17-dong-luong-va-va-cham',
  'lop-10/chuong-4-chuyen-dong-tron-va-bien-dang/bai-18-dong-hoc-chuyen-dong-tron-deu',
  'lop-10/chuong-4-chuyen-dong-tron-va-bien-dang/bai-19-gia-toc-huong-tam-va-luc-huong-tam',
  'lop-10/chuong-4-chuyen-dong-tron-va-bien-dang/bai-20-su-bien-dang-dinh-luat-hooke',
  'lop-11/chuong-1-dao-dong/bai-1-dao-dong-dieu-hoa-phuong-trinh-dao-dong-dieu-hoa',
  'lop-11/chuong-1-dao-dong/bai-2-van-toc-gia-toc-trong-dao-dong-dieu-hoa',
  'lop-11/chuong-1-dao-dong/bai-3-nang-luong-trong-dao-dong-dieu-hoa',
  'lop-11/chuong-1-dao-dong/bai-4-dao-dong-tat-dan-cuong-buc-cong-huong',
  'lop-11/chuong-2-song/bai-5-mo-ta-song-su-truyen-song',
  'lop-11/chuong-2-song/bai-6-cac-dac-trung-cua-song-song-doc-va-song-ngang',
  'lop-11/chuong-2-song/bai-7-song-dien-tu',
  'lop-11/chuong-2-song/bai-8-giao-thoa-song',
  'lop-11/chuong-2-song/bai-9-song-dung',
  'lop-11/chuong-2-song/bai-10-do-toc-do-truyen-am',
  'lop-11/chuong-3-dien-truong/bai-11-luc-tuong-tac-giua-cac-dien-tich-dinh-luat-coulomb',
  'lop-11/chuong-3-dien-truong/bai-12-khai-niem-dien-truong-dien-truong-deu',
  'lop-11/chuong-3-dien-truong/bai-13-dien-the-va-the-nang-dien',
  'lop-11/chuong-3-dien-truong/bai-14-dien-dung-va-tu-dien-nang-luong-dien-truong',
  'lop-11/chuong-4-dong-dien-mach-dien/bai-15-dong-dien-cuong-do-dong-dien',
  'lop-11/chuong-4-dong-dien-mach-dien/bai-16-dien-tro-dinh-luat-ohm',
  'lop-11/chuong-4-dong-dien-mach-dien/bai-17-nguon-dien',
  'lop-11/chuong-4-dong-dien-mach-dien/bai-18-nang-luong-dien-cong-suat-dien',
  'lop-12/chuong-1-vat-li-nhiet/bai-1-su-chuyen-the',
  'lop-12/chuong-1-vat-li-nhiet/bai-2-noi-nang-dinh-luat-1-cua-nhiet-dong-luc-hoc',
  'lop-12/chuong-1-vat-li-nhiet/bai-3-thang-nhiet-do-nhiet-ke',
  'lop-12/chuong-1-vat-li-nhiet/bai-4-nhiet-dung-rieng',
  'lop-12/chuong-1-vat-li-nhiet/bai-5-nhiet-nong-chay-rieng',
  'lop-12/chuong-1-vat-li-nhiet/bai-6-nhiet-hoa-hoi-rieng',
  'lop-12/chuong-2-khi-li-tuong/bai-7-mo-hinh-dong-hoc-phan-tu-chat-khi',
  'lop-12/chuong-2-khi-li-tuong/bai-8-dinh-luat-boyle',
  'lop-12/chuong-2-khi-li-tuong/bai-9-dinh-luat-charles',
  'lop-12/chuong-2-khi-li-tuong/bai-10-phuong-trinh-trang-thai-cua-khi-li-tuong',
  'lop-12/chuong-2-khi-li-tuong/bai-11-ap-suat-theo-mo-hinh-dong-hoc-phan-tu-dong-nang-phan-tu',
  'lop-12/chuong-3-tu-truong/bai-12-tu-truong',
  'lop-12/chuong-3-tu-truong/bai-13-luc-tu-tac-dung-len-doan-day-dan-mang-dong-dien-cam-ung-tu',
  'lop-12/chuong-3-tu-truong/bai-14-tu-thong-hien-tuong-cam-ung-dien-tu',
  'lop-12/chuong-3-tu-truong/bai-15-may-phat-dien-xoay-chieu-dai-cuong-ve-dong-dien-xoay-chieu',
  'lop-12/chuong-3-tu-truong/bai-16-ung-dung-cua-hien-tuong-cam-ung-dien-tu',
  'lop-12/chuong-3-tu-truong/bai-17-dien-tu-truong-mo-hinh-song-dien-tu',
  'lop-12/chuong-4-vat-li-hat-nhan/bai-18-cau-truc-hat-nhan',
  'lop-12/chuong-4-vat-li-hat-nhan/bai-19-do-hut-khoi-va-nang-luong-lien-ket-hat-nhan',
  'lop-12/chuong-4-vat-li-hat-nhan/bai-20-su-phan-hach-va-tong-hop-hat-nhan',
  'lop-12/chuong-4-vat-li-hat-nhan/bai-21-phong-xa-an-toan-phong-xa',
  'lop-12/chuong-4-vat-li-hat-nhan/bai-22-cong-nghiep-hat-nhan',
]

export interface CurriculumItem {
  path: string
  lop: number
  chuong: number
  bai: number
  title: string
}

function prettifyTitle(path: string): string {
  const last = path.split('/').pop() || ''
  const noPrefix = last.replace(/^bai-\d+-/, '').replace(/-/g, ' ')
  return noPrefix.charAt(0).toUpperCase() + noPrefix.slice(1)
}

export function listCurriculum(): CurriculumItem[] {
  return CURRICULUM_PATHS.map((path) => {
    const lop = Number(path.match(/lop-(\d+)/)?.[1] || 0)
    const chuong = Number(path.match(/chuong-(\d+)/)?.[1] || 0)
    const bai = Number(path.match(/bai-(\d+)/)?.[1] || 0)
    return { path, lop, chuong, bai, title: prettifyTitle(path) }
  })
}

export interface InheritedLesson {
  title: string
  description: string
  items: ContentItem[]
}

// Nạp nội dung gốc của một bài và gộp 3 phần thành ContentItem[] phẳng.
export async function fetchInheritedLesson(path: string): Promise<InheritedLesson> {
  const res = await fetch(`/du-lieu/noi-dung/${path}/noi-dung.json`)
  if (!res.ok) throw new Error(`Không tải được bài gốc: ${path}`)
  const raw = await res.json()
  const sections = ['phanMoDau', 'phanNoiDung', 'phanCuoi']
  const items: ContentItem[] = []
  for (const s of sections) {
    const part = raw?.noiDung?.[s]
    if (part?.tieuDe) items.push({ type: 'heading', content: part.tieuDe, level: 2 })
    if (Array.isArray(part?.noiDung)) items.push(...part.noiDung)
  }
  return {
    title: raw?.tieuDe || prettifyTitle(path),
    description: raw?.moTa || '',
    items,
  }
}
